<div class="error-view">
    <h2>{{'error.fullLabel' | translate}}</h2>
    <h3 *ngIf="code && message">{{ code }} - {{ message }}</h3>
    <div [innerHTML]="'error.detail' | translate"></div>
</div>
